import { GetStaticPaths, GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {
  getFilterOptions,
  getFooterLinks,
  getDynamicBanners
} from '../../new-lib/apis';
import HomePageContainer from '../../features/home';
import {
  setIsMobile
} from '../../redux/actions/appActions';
import { wrapper } from '../../redux/store';
import { StaticPagesUtility } from '../../new-lib/utilities/static-pages.utility';
import { PathwaysApis } from '../../new-lib/apis/pathways.apis';
import { AreasApis } from '../../new-lib/apis/areas.apis';
import { CompoundsApis } from '../../new-lib/apis/compounds.apis';
import { SCHEMA_TYPES } from '../../features/structured-data/components/SchemaBuilder';
import { SeoUtils } from '../../new-lib/utilities/seo-utils';
import { LaunchesApis } from '../../new-lib/apis/launches.apis';
import { DevelopersApis } from '../../new-lib/apis/developers.apis';

const Home = (props: any) => {
  return (
    <>
      <HomePageContainer {...props} />
    </>
  );
};

export const getStaticProps = wrapper.getStaticProps(
  store =>
    async ({ params, locale }: GetStaticPropsContext) => {
      const [
        pathways,
        popularCompounds,
        topAreas,
        launches,
        filterOptions,
        footerLinks,
        areas,
        developers,
        dynamicBanners
      ] = await Promise.all([
        PathwaysApis.getPathways('home_page', locale),
        CompoundsApis.getPopularCompounds({ page: 1, pageSize: 10 }, locale),
        AreasApis.list({ page: 1, pageSize: 8 }, locale),
        LaunchesApis.getLaunchesSummary(locale),
        getFilterOptions(locale),
        getFooterLinks(locale, 'home'),
        AreasApis.listAll(locale),
        DevelopersApis.listAll(locale),
        getDynamicBanners(locale)
      ]);

      store.dispatch(setIsMobile(params?.device === 'mobile'));

      return {
        revalidate: 60 * 5,
        props: {
          ...(await serverSideTranslations(locale as string, [
            'home',
            'common',
            'contact',
            'search',
            'launches',
            'compare',
            'map'
          ])),
          layout: {
            title: SeoUtils.getHomepageMetaTitle(locale),
            metaDescription: SeoUtils.getHomepageMetaDescription(locale),
            url: process.env.NEXT_PUBLIC_HOST,
            footerLinks,
            path: '/'
          },
          filterOptions: JSON.stringify(filterOptions),
          topAreas,
          pathways,
          popularCompounds,
          launches,
          areas,
          developers,
          dynamicBanners,
          schemas: [SCHEMA_TYPES.organization]
        }
      };
    }
);

export const getStaticPaths = (async () => {
  return { paths: StaticPagesUtility.get(), fallback: false };
}) satisfies GetStaticPaths;

export default Home;
